export type TargetThemeModes = 'main' | 'all';
export const TARGET_THEME_MODES = ['main', 'all'];
